module.exports = __webpack_public_path__ + "img/a-banner4.38ad7df3.png";